'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Immutable = require('Immutable');

var _ = require('_');

var _sha = require('event-tracking-tools/vendor/sha1');

var _sha2 = _interopRequireDefault(_sha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reduceToString(hashableObject) {
  return (0, _.reduce)(hashableObject, function (accumulator, value, key) {
    accumulator += key;
    var isFunc = (0, _.isFunction)(value);
    var isObj = (0, _.isObject)(value);
    var isEventPropType = isFunc && value.isEventPropType;
    if (!isObj && !isFunc) {
      accumulator += String(value);
    }
    if (isEventPropType) {
      accumulator += value.getStringValue();
    }
    return accumulator;
  }, '');
}

function createRecordHash(record) {
  var propTypes = record.propTypes;
  var propTypeKeysValues = propTypes ? reduceToString(propTypes) : '';

  var recordAsMap = (0, _Immutable.Map)(record.toJS());
  var hashable = recordAsMap.delete('useStrict').delete('propTypes').delete('__propTypes__').toJS();

  var topLevelKeysValues = reduceToString(hashable);
  var combinedStringValue = '' + topLevelKeysValues + propTypeKeysValues;
  var hashed = (0, _sha2.default)(combinedStringValue);
  return hashed.slice(0, 20);
}

exports.default = createRecordHash;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/utils/createRecordHash.js
// module id = 543
// module chunks = 0